<div class="modal-header" style="border-bottom: 1px solid #DDD;">
  <div class="d-flex justify-content-between w-100 py-2 align-items-center" style="height: 55px;">
    <h2 class="card-title mb-0">Delegations</h2>
    <button
      type="button"
      class="btn-close close pull-right"
      style="margin-top: 1px; margin-left: 8px;"
      aria-label="Close"
      (click)="closeModal()"
    >
      <span aria-hidden="true" class="visually-hidden">&times;</span>
    </button>
  </div>
</div>
<div class="modal-body">
  <div class="delegation-widget" *ngIf="userId">
    <div class="delegation-widget-inner">
      <p class="delegation-hint text-muted small mb-2">
        Search and add a user who may act on your behalf.
      </p>

      <div
        *ngIf="delegationUserOptions.length > 0"
        class="d-flex flex-wrap gap-2 align-items-end mb-3"
      >
        <div class="flex-grow-1 delegation-select-wrap">
          <label class="visually-hidden" for="delegation-grantee-select-modal">Delegate to user</label>
          <ng-select
            id="delegation-grantee-select-modal"
            [items]="delegationUserOptions"
            bindLabel="label"
            bindValue="id"
            [(ngModel)]="selectedDelegationGranteeId"
            placeholder="Search user..."
            [searchable]="true"
            [clearable]="true"
            appendTo="body"
            class="delegation-ng-select"
          ></ng-select>
        </div>
        <button
          type="button"
          class="btn btn-primary delegation-add-btn"
          [disabled]="!selectedDelegationGranteeId || isAddingDelegation"
          (click)="onAddDelegation()"
        >
          {{ isAddingDelegation ? 'Adding…' : 'Add' }}
        </button>
      </div>
      <p *ngIf="delegationUserOptions.length === 0" class="text-muted small mb-3">
        No other users are available in your organization to add as delegations.
      </p>

      <div *ngIf="delegatedUsersList.length > 0" class="delegation-current-list">
        <div class="delegation-subheading small text-muted mb-2">Current delegates</div>
        <ul class="list-group delegation-list-group">
          <li
            *ngFor="let d of delegatedUsersList"
            class="list-group-item d-flex justify-content-between align-items-start gap-2 px-3 py-2"
          >
            <div class="me-2 flex-grow-1 min-w-0">
              <div class="delegation-name">{{ d.firstName }} {{ d.lastName }}</div>
              <div class="small text-muted" *ngIf="d.email">{{ d.email }}</div>
              <div class="small text-muted" *ngIf="d.phone && !d.email">{{ d.phone }}</div>
            </div>
            <div class="d-flex flex-shrink-0 align-items-center gap-2 flex-wrap justify-content-end">
              <span class="badge text-bg-light text-secondary fw-normal" *ngIf="d.title">{{ d.title }}</span>
              <button
                type="button"
                class="btn btn-link btn-sm p-1 delegation-remove-icon-btn"
                [disabled]="!d.delegationId || deletingDelegationId !== null || isAddingDelegation"
                [attr.aria-label]="isDeletingDelegation(d.delegationId) ? 'Removing delegation' : 'Remove delegation'"
                [attr.aria-busy]="isDeletingDelegation(d.delegationId)"
                title="Remove delegation"
                (click)="onDeleteDelegation(d)"
              >
                <i
                  *ngIf="!isDeletingDelegation(d.delegationId)"
                  class="fa-solid fa-trash-can"
                  aria-hidden="true"
                ></i>
                <i
                  *ngIf="isDeletingDelegation(d.delegationId)"
                  class="fa-solid fa-spinner fa-spin"
                  aria-hidden="true"
                ></i>
              </button>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
